import MonitoringServiceConfirmReceptModal from './monitoring-service-confirm-recept-modal.vue'
export default MonitoringServiceConfirmReceptModal
